(function () {
    'use strict';

    angular
        .module('app.users')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
             {
                 state: 'users',
                 config: {
                     abstract: true,
                     url: '/users',
                     template: '<ui-view/>',
                     settings: {
                         authMode: 1
                     },
                     resolve: {
                         authenticationRequired: ['userService', function (userService) {
                             userService.isAuthenticatedThrowError();
                             if (userService.userType() != "2") {
                                 throw { name: "NotAdmin" };
                             }
                         }]
                     }
                 }
             },
            {
                state: 'users.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/users/list.html?v=' + opsIncludeVersion,
                    controller: 'UsersListController',
                    controllerAs: 'vm',
                    title: 'Users'
                }
            },
             {
                 state: 'users.details',
                 config: {
                     url: '/detail/:id',
                     templateUrl: 'app/users/details.html?v=' + opsIncludeVersion,
                     controller: 'UserDetailsController',
                     controllerAs: 'vm',
                     title: 'User',
                     settings: {}
                 }
             }
        ];
    }
})();
